import Rate from './Rate';
export default Rate;



// WEBPACK FOOTER //
// ./_rc-rate-1.1.2/src/index.js